<!-- Card Content -->
<p-card header="{{ titleText | translate }}">
  <ng-content></ng-content>
</p-card>